import { useEffect } from "react";
import { toast } from "sonner";
import { Copy, Globe, RotateCcw } from "lucide-react";
import { copyText, playUhOh } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

export const RetroSuccess = ({ result, onReset }) => {
  const { t } = useI18n();
  useEffect(() => { playUhOh(); }, []);
  const copy = async () => {
    await copyText(String(result.uin));
    toast.success(t("uinCopied"), { description: String(result.uin) });
  };
  return (
    <div data-testid="register-success" className="space-y-4">
      <p className="font-bold">{t("rtCongrats")}</p>
      <p data-testid="register-success-uin" className="w98-sunken bg-white px-3 py-3 text-3xl sm:text-4xl font-bold tracking-widest text-[#000080] text-center break-all">
        {result.uin}
      </p>
      {result.nickname && <p>{t("welcome")} {result.nickname}</p>}
      <div className="grid grid-cols-2 gap-2 text-sm">
        <p>{t("sServer")}: <b data-testid="register-success-server">{result.server_host}</b></p>
        <p>{t("sPort")}: <b data-testid="register-success-port">{result.server_port}</b></p>
      </div>
      <p className="text-sm text-[#800000]">{t("writeDown")}</p>
      <div className="flex flex-wrap justify-end gap-2">
        <button type="button" onClick={copy} className="w98-btn primary" data-testid="copy-uin-btn"><Copy className="h-4 w-4" />{t("copyUin")}</button>
        <a href="https://kicq.su" target="_blank" rel="noopener noreferrer" className="w98-btn" data-testid="success-webclient-btn"><Globe className="h-4 w-4" />{t("loginWeb")}</a>
        <button type="button" onClick={onReset} className="w98-btn" data-testid="register-another-btn"><RotateCcw className="h-4 w-4" />{t("another")}</button>
      </div>
    </div>
  );
};
